import { useQuery } from "@tanstack/react-query";
import type {
  DEProcess,
  Process,
  ProcessResponse,
} from "../../models/lab.models";
import { getLabProcess } from "../../repositories/lab-de.repositories";

export const useLabProcessQuery = (
  processId: number | null,
  isEditing = false,
) => {
  return useQuery<DEProcess, Error>({
    queryKey: ["lab-process", processId],
    queryFn: async ({ signal }) => {
      const resp = await getLabProcess({ ProcessId: processId, signal });
      if (!resp.ok) throw new Error(resp.message ?? "Failed to load process");
      const data = resp.data as ProcessResponse;
      const process = data.tables["0"].rows[0] as Process;
      return { process };
    },
    enabled: processId != null,
    keepPreviousData: true,
    refetchInterval: (data) => {
      if (isEditing) return false;
      if (data?.process?.IsOldProcess) return false;
      return 10_000;
    },
  });
};
